/** 与 uploadWorkspace 页一致：object-fit:contain 内实际画面矩形与 ROI 约束 */

export function getContainFitTransform(
  sourceW: number,
  sourceH: number,
  targetW: number,
  targetH: number
): { scale: number; offsetX: number; offsetY: number; displayedW: number; displayedH: number } {
  const scale = Math.min(targetW / sourceW, targetH / sourceH);
  const displayedW = sourceW * scale;
  const displayedH = sourceH * scale;
  const offsetX = (targetW - displayedW) / 2;
  const offsetY = (targetH - displayedH) / 2;
  return { scale, offsetX, offsetY, displayedW, displayedH };
}

export function clampRoiToContainRect(
  roi: { x: number; y: number; width: number; height: number },
  offsetX: number,
  offsetY: number,
  displayedW: number,
  displayedH: number,
  minW = 60,
  minH = 30
): { x: number; y: number; width: number; height: number } {
  const w = Math.min(Math.max(roi.width, minW), displayedW);
  const h = Math.min(Math.max(roi.height, minH), displayedH);
  const x = Math.max(offsetX, Math.min(roi.x, offsetX + displayedW - w));
  const y = Math.max(offsetY, Math.min(roi.y, offsetY + displayedH - h));
  return { x, y, width: w, height: h };
}
